var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9523 22C14.6396 22 15.1265 21.4081 15.4797 20.4916L21.7327 4.15752C21.9045 3.71838 22 3.32697 22 3.00239C22 2.38186 21.6181 2 20.9976 2C20.673 2 20.2816 2.09547 19.8425 2.2673L3.42243 8.55847C2.62053 8.86396 2 9.35084 2 10.0477C2 10.926 2.66826 11.222 3.58473 11.4988L10.4773 13.5227L12.4821 20.3294C12.759 21.2936 13.0644 22 13.9523 22ZM10.9069 12.0716L4.31981 10.0573C4.15752 10.0095 4.11933 9.97136 4.11933 9.90453C4.11933 9.83771 4.15752 9.78998 4.30072 9.7327L17.2076 4.84487C17.9714 4.55847 18.6969 4.17661 19.4129 3.85203C18.7828 4.36754 17.9905 4.97852 17.4749 5.50358L10.9069 12.0716ZM14.0955 19.8998C14.0286 19.8998 13.9905 19.8329 13.9332 19.6802L11.9189 13.0931L18.4964 6.52506C19.0119 6.00955 19.6516 5.20764 20.1575 4.55847C19.8329 5.28401 19.4415 6.01909 19.1551 6.79236L14.2578 19.6993C14.21 19.8425 14.1623 19.8998 14.0955 19.8998Z",
    fill: "#878793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.274b68ddc6e46cea227944a3a0c719d4.svg";
export { ForwardRef as ReactComponent };